import Vue from "vue";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/noto-sans-tc/400.css";
import "@fontsource/noto-sans-tc/500.css";
import "@fontsource/noto-sans-tc/700.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ToastPlugin from "./plugins/toast";
import { buildLabel } from "./utils/buildInfo";

Vue.config.productionTip = false;
Vue.use(ToastPlugin);
Vue.prototype.$buildLabel = buildLabel;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");

